"use client"

import { Toaster as Sonner, type ToasterProps } from "sonner"

function Toaster({ ...props }: ToasterProps) {
  return <Sonner richColors {...props} />
}

export { Toaster }
